import angular from 'angular';
import sha256 from 'js-sha256';
import sha512 from 'js-sha512';
import { Param } from 'angular-ui-router';
class SignatureVerifyController {
    constructor($previousState, $state, $filter, $scope, AppConfig, EvidenceAPI, message, FileUploader) {
        "ngInject";
        this.tranlsteFilter = $filter('translate');
        this.$previousState = $previousState;
        this.$state = $state
        const self = this
      console.log(this.$state)
        this.tipsObj = {}
        this.fingerType={
           0:"SHA256",
           1:"SM3"
        }
        
        FileUploader.FileSelect.prototype.isEmptyAfterSelection = function() {
            return true; // true|false
        };


        this.packageUploader = new FileUploader({
            url: AppConfig.server_url + '/evidences/package/verify',
            withCredentials: true,
            alias: 'package_file',
            filters: [
                {
                    name: 'type',
                    fn: function (item) {
                        console.log(item.type)
                        if (/\.zip/.test(item.name) || /zip/.test(item.type)) {
                            return true
                        }
                        message.error(self.tranlsteFilter('home-evidences-text055'));
                        return false
                    }
                }
            ],
            onSuccessItem: (item, res) => {
                  if (res.status.code === 200) {
                     this.tipsObj = res.data
                     $state.go('app.page.verify.main.tsa.success',{id:223})
                  } else {
                     this.errorMessage = res.status.message
                     $state.go('app.page.verify.main.tsa.error')
                  }
                  this.packageUploader.clearQueue();
            }
        })

        this.EvidenceAPI = EvidenceAPI;
        this.message = message;
    }



    onSubmit (form) {
        if (form.$invalid) return
        this.EvidenceAPI.one('tsa').post('verify', {
            hash: this.formData.hash,
            // tsa_sign: this.formData.sign,
            // tsa_time: this.formData.time
        }).then(res => {
            if (res.status.code === 200) {
                this.message.success(this.tranlsteFilter('home-evidences-text044'))
            } else {
                this.message.error(this.tranlsteFilter('home-evidences-text051'))
            }
        })
    }

    submitFile () {
        this.packageUploader.uploadAll()
    }

    back () {
        this.$previousState.go()
    }
}

export default SignatureVerifyController;



// WEBPACK FOOTER //
// ./src/app/components/page/verify/signature-verify/signature-verify.controller.js